<template>
    <div class="mds-form__select mds-form__field-group" :class="{ 'mds-form--error': error }">
        <select :id="id" class="mds-form__select-input" v-model="model" @change="handleChange">
            <option
                class="mds-form__select-option"
                v-for="option in options"
                :key="option.value"
                :value="option.value"
                :selected="option.default"
                :disabled="option.disabled"
            >
                {{option.label}}
            </option>
        </select>
        <div class="mds-form__select-visual-wrap"></div>
        <span class="mds-form__select-open-indicator">
            <CaretDownSVG class="mds-icon mds-form__select-open-icon" aria-hidden="true" />
        </span>
        <div v-if="error" class="error">{{errorMessage}}</div>
    </div>
</template>

<script>
import _ from "lodash";
import CaretDownSVG from "@mds-assets/mds_icons.svg?caret-down--s";

export default {
    props: {
        options: {
            type: Array
        },
        type: {
            type: String
        },
        error: {
            type: Boolean
        },
        errorMessage: {
            type: String
        },
        id: {
            type: String,
            required: true
        }
    },
    components: {
        CaretDownSVG
    },
    data () {
        const model = _.find(this.options, "default");
        return {
            model: _.get(model, "value", null)
        };
    },
    methods: {
        handleChange () {
            const { type, options } = this;
            const value = this.model;
            this.$emit("onSelectChange", {
                type,
                item: _.find(options, { value })
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.error {
    font-size: $mds-font-size-s;
    color: $mds-color-red-50;
}
</style>




// WEBPACK FOOTER //
// src/components/Select.vue